var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.noLink)?_c('div'):(_vm.onlyOneLink)?_c('TheSettingsSingleLink',{attrs:{"link":_vm.links[0]}}):_c('TheSettingsSpeedDial',{attrs:{"links":_vm.links}})}
var staticRenderFns = []

export { render, staticRenderFns }